import { render, staticRenderFns } from "./homeSchool.vue?vue&type=template&id=39240860&scoped=true"
import script from "./homeSchool.vue?vue&type=script&lang=js"
export * from "./homeSchool.vue?vue&type=script&lang=js"
import style0 from "./homeSchool.vue?vue&type=style&index=0&id=39240860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39240860",
  null
  
)

export default component.exports